export const PASSWORD_RULES_ATTR =
  "minlength: 8; required: upper; required: lower; required: digit; required: special;";

export const PASSWORD_SYMBOL_PATTERN = /[!@#$%^&*()_+\-=[\]{};':"\\|<>?,./`~.]/;

export function getPasswordRequirementStatus(password = "") {
  const value = String(password || "");
  return {
    minLength: value.length >= 8,
    uppercase: /[A-Z]/.test(value),
    lowercase: /[a-z]/.test(value),
    number: /[0-9]/.test(value),
    symbol: PASSWORD_SYMBOL_PATTERN.test(value),
  };
}

export function meetsPasswordPolicy(password = "") {
  const status = getPasswordRequirementStatus(password);
  return (
    status.minLength &&
    status.uppercase &&
    status.lowercase &&
    status.number &&
    status.symbol
  );
}

function pickCharacter(characters) {
  const source = String(characters || "");
  if (!source) return "";
  const array = new Uint32Array(1);
  if (typeof crypto !== "undefined" && crypto.getRandomValues) {
    crypto.getRandomValues(array);
    return source[array[0] % source.length];
  }
  return source[Math.floor(Math.random() * source.length)];
}

function shuffleCharacters(value) {
  const chars = String(value || "").split("");
  for (let i = chars.length - 1; i > 0; i -= 1) {
    const random = new Uint32Array(1);
    let j;
    if (typeof crypto !== "undefined" && crypto.getRandomValues) {
      crypto.getRandomValues(random);
      j = random[0] % (i + 1);
    } else {
      j = Math.floor(Math.random() * (i + 1));
    }
    [chars[i], chars[j]] = [chars[j], chars[i]];
  }
  return chars.join("");
}

export function generateCompliantPassword(length = 18) {
  const uppercase = "ABCDEFGHJKLMNPQRSTUVWXYZ";
  const lowercase = "abcdefghijkmnopqrstuvwxyz";
  const numbers = "23456789";
  const symbols = "!@#$%^&*?";
  const all = `${uppercase}${lowercase}${numbers}${symbols}`;
  const targetLength = Math.max(12, Number(length) || 18);
  let password =
    pickCharacter(uppercase) +
    pickCharacter(lowercase) +
    pickCharacter(numbers) +
    pickCharacter(symbols);

  while (password.length < targetLength) {
    password += pickCharacter(all);
  }

  const shuffled = shuffleCharacters(password);
  return meetsPasswordPolicy(shuffled) ? shuffled : `${shuffled}A7!a`;
}
